'use client'

import Link from '@/components/link-locale'
import { useAsideStore } from '@/store'
import clsx from 'clsx'
import { useLocale, useTranslations } from 'next-intl'
import { usePathname } from 'next/navigation'
import React from 'react'
import {
  AiOutlineHome,
  AiOutlineMenu,
  AiOutlineRead,
  AiOutlineSearch,
} from 'react-icons/ai'

export default function BottomNav() {
  const t = useTranslations()
  const pathname = usePathname()
  const locale = useLocale()

  const relativePath = pathname.replace(`/${locale}`, '/').replace('//', '/')

  const setAsideVisible = useAsideStore(state => state.setVisible)

  return (
    <div className='fixed bottom-0 left-0 right-0 z-30 grid h-20 w-dvw grid-cols-4 bg-[#27272E]'>
      <Link href='/'>
        <div
          className={clsx([
            'flex h-full flex-col items-center justify-center gap-y-2 text-[#7A828A] hover:text-primary',
            { 'text-primary': relativePath === '/' },
          ])}
        >
          <AiOutlineHome className='text-3xl' />
          <span className='text-sm font-semibold'>{t('header.home')}</span>
        </div>
      </Link>
      <Link href='/search'>
        <div
          className={clsx([
            'flex h-full flex-col items-center justify-center gap-y-2 text-[#7A828A] hover:text-primary',
            { 'text-primary': relativePath === '/search' },
          ])}
        >
          <AiOutlineSearch className='text-3xl' />
          <span className='text-sm font-semibold'>{t('common.search')}</span>
        </div>
      </Link>
      <Link href='/feed/videos'>
        <div
          className={clsx([
            'flex h-full flex-col items-center justify-center gap-y-2 text-[#7A828A] hover:text-primary',
            { 'text-primary': relativePath === '/feed/videos' },
          ])}
        >
          <AiOutlineRead className='text-3xl' />
          <span className='text-sm font-semibold'>{t('header.category')}</span>
        </div>
      </Link>
      <div
        className='flex h-full flex-col items-center justify-center gap-y-2 text-[#7A828A] hover:text-primary'
        onClick={() => setAsideVisible(true)}
      >
        <AiOutlineMenu className='text-3xl' />
        <span className='text-sm font-semibold'>{t('common.menu')}</span>
      </div>
    </div>
  )
}
